import React, { FC } from 'react';
import { Text } from '../../../../../components/common';

interface Props {
  className?: string;
}

export const NavItemTitle: FC<Props> = (props) => {
  return <Text weight="bold" size="small" tagName="div" className={props.className} {...props} />;
};
